"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var banner_data_1 = require("./banner_data");
var banner_styles_1 = require("./banner_styles");
var styles_2 = require("../styles");
var merge_1 = __importDefault(require("lodash/merge"));
var useStyles = styles_1.makeStyles(banner_styles_1.styles);
var BannerComponent = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'warning' : _b, receivedIcon = _a.icon, _c = _a.classes, receivedClasses = _c === void 0 ? {} : _c, _d = _a.customClasses, oldCustomClasses = _d === void 0 ? {} : _d, children = _a.children;
    var theme = styles_1.useTheme();
    var _e = react_1.useMemo(function () {
        var typeConfig = banner_data_1.BANNER_DATA[type];
        if (!typeConfig) {
            return banner_data_1.BANNER_DATA.default;
        }
        return __assign(__assign({}, typeConfig), { color: styles_2.getComponentColor(true, styles_2.getHexFromTheme(theme, typeConfig.color), false) });
    }, [type, theme]), icon = _e.icon, color = _e.color;
    var mergedClasses = react_1.useMemo(function () { return merge_1.default({}, oldCustomClasses, receivedClasses); }, [
        JSON.stringify(oldCustomClasses),
        JSON.stringify(receivedClasses),
    ]);
    var classes = useStyles({ classes: mergedClasses });
    var Icon = receivedIcon || icon;
    return (react_1.default.createElement("div", { className: classnames_1.default(classes.container), style: { color: color } },
        react_1.default.createElement("span", { className: classes.iconContainer }, Icon && react_1.default.createElement(Icon, null)),
        children));
};
exports.Banner = BannerComponent;
